import React from "react";
import "../scss/component/_siteCard.scss";
import rightIcon from "../assets/icons/right-arrow.png";
import storeIcon from "../assets/icons/store.png";
import utils from "../helpers/utils";

interface CardProps {
  icon?: React.ReactNode;
  title?: string;
  address?: string;
  status?: string;
  time?: string;
  distance?: number;
  selected?: boolean;
  onClick?: () => void;
}

const SiteCard: React.FC<CardProps> = ({
  icon,
  title,
  address,
  status,
  time,
  distance,
  selected,
  onClick,
}) => {
  const siteAddress = utils.formatAddress(address);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "var(--white-color)",
        border: selected
          ? "2px solid var(--main-turquoise)"
          : "var(--white-color)",
        borderRadius: "12px",
        boxShadow: "0px 3px 5px rgba(0,0,0,0.1)",
        padding: "16px",
        cursor: "pointer",
        transition: "background 0.2s ease, border 0.2s ease",
      }}
      onClick={onClick}
    >
      <div
        className="t14"
        style={{
          flex: "0 0 60px",
          height: "50px",
          width: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "16px",
        }}
      >
        <img
          src={storeIcon}
          alt={"store-icon"}
          style={{
            width: 20,
            fill: "#fff",
            background: "#fff",
            height: 20,
            objectFit: "contain",
          }}
        />
      </div>
      <div style={{ flex: 1, letterSpacing: 0.5 }}>
        <h3
          className="t16"
          style={{
            fontWeight: 500,
          }}
        >
          {title}
        </h3>
        <p
          style={{
            color: "var(--main-color)",
            marginBottom: 1
          }}
          className="t14"
        >
          {siteAddress.line1} {siteAddress.line2}
        </p>
        <p
          style={{
            margin: 0,
            color: "var(--text-color)",
            display: "flex",
            flexWrap: 'wrap',
            alignItems: "center",
            marginTop: 2,
            gap: "6px",
          }}
          className="t12"
        >
          <span>{status}</span>
          <span
            style={{
              color: "var(--text-color)",
            }}
          >
            |
          </span>
          <span>{time}</span>
          <span
            style={{
              color: "var(--text-color)",
            }}
          >
            |
          </span>
          <span>{`${distance}km`}</span>
        </p>
      </div>
      <div>
        <img
          src={rightIcon}
          alt={"no found"}
          style={{
            width: 15,
            fill: selected ? "#fff" : "var(--main-color)",
            height: 15,
            objectFit: "contain",
          }}
        />
      </div>
    </div >
  );
};

export default SiteCard;
